import { render, staticRenderFns } from "./remarkDialog.vue?vue&type=template&id=7c98fb9e&scoped=true&"
import script from "./remarkDialog.vue?vue&type=script&lang=js&"
export * from "./remarkDialog.vue?vue&type=script&lang=js&"
import style0 from "./remarkDialog.vue?vue&type=style&index=0&id=7c98fb9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c98fb9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c98fb9e')) {
      api.createRecord('7c98fb9e', component.options)
    } else {
      api.reload('7c98fb9e', component.options)
    }
    module.hot.accept("./remarkDialog.vue?vue&type=template&id=7c98fb9e&scoped=true&", function () {
      api.rerender('7c98fb9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/CustomPitLocation/modules/remarkDialog.vue"
export default component.exports